export const graphType = [
  {
    id: 0,
    graph: "CO₂ Saved",
  },
  {
    id: 1,
    graph: "User",
  },
  {
    id: 2,
    graph: "Modes",
  },
];
